import React from 'react'
import styles from './NotAvailableText.styles'
import transl from './NotAvailableText.transl'

/**
 * Returns the translation text for 'Not Available' with light gray text color
 * In order to pass on the translated text to helper functions or non React components
 */
function NotAvailableText() {
  return <span css={styles.textColor()}>{transl.notAvailable()}</span>
}

export default React.memo(NotAvailableText)
